(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nh-bundle-fbt"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('[id^="nhb-"]');
    if (!root) return;

    var addons = root.querySelectorAll('.nhb__product--addon');
    var totalEl = root.querySelector('[data-nhb-total]');
    var compareEl = root.querySelector('[data-nhb-compare-total]');
    var savingsEl = root.querySelector('[data-nhb-savings]');
    var savingsBadge = root.querySelector('[data-nhb-savings-badge]');
    var btnText = root.querySelector('[data-nhb-btn-text]');
    var ctaBtn = root.querySelector('[id^="nhb-add-all"]');
    var mainProduct = root.querySelector('.nhb__product--main');

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '\u00A0\u20AC';
    }

    function recalc() {
      var mainPrice = parseInt(mainProduct.getAttribute('data-nhb-price')) || 0;
      var mainCompare = parseInt(mainProduct.getAttribute('data-nhb-compare')) || mainPrice;
      var total = mainPrice;
      var compare = mainCompare;
      var count = 1;

      addons.forEach(function(card) {
        var cb = card.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) {
          total += parseInt(card.getAttribute('data-nhb-price')) || 0;
          compare += parseInt(card.getAttribute('data-nhb-compare')) || parseInt(card.getAttribute('data-nhb-price')) || 0;
          count++;
          card.classList.remove('is-off');
        } else {
          card.classList.add('is-off');
        }
      });

      if (totalEl) totalEl.textContent = formatMoney(total);
      if (compareEl) {
        compareEl.textContent = formatMoney(compare);
        compareEl.style.display = compare > total ? '' : 'none';
      }
      if (savingsEl && savingsBadge) {
        if (compare > total) {
          savingsEl.textContent = formatMoney(compare - total);
          savingsBadge.style.display = '';
        } else {
          savingsBadge.style.display = 'none';
        }
      }
      if (btnText) {
        btnText.textContent = count > 1
          ? 'Alle ' + count + ' zusammen in den Warenkorb'
          : 'In den Warenkorb';
      }
    }

    addons.forEach(function(card) {
      var cb = card.querySelector('input[type="checkbox"]');
      if (cb) cb.addEventListener('change', recalc);

      var sel = card.querySelector('[data-nhb-select]');
      if (!sel) return;

      var variants = JSON.parse(card.getAttribute('data-nhb-variants'));
      var fallbackImg = card.getAttribute('data-nhb-fallback-img');
      var productUrl = card.getAttribute('data-nhb-product-url');

      sel.addEventListener('change', function() {
        var vid = parseInt(sel.value, 10);
        var chosen = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === vid) { chosen = variants[i]; break; }
        }
        if (!chosen) return;

        card.setAttribute('data-nhb-variant', chosen.id);
        card.setAttribute('data-nhb-price', chosen.price);
        card.setAttribute('data-nhb-compare', chosen.compare || chosen.price);

        var priceEl = card.querySelector('[data-nhb-addon-price]');
        var compareAddonEl = card.querySelector('[data-nhb-addon-compare]');
        var imgEl = card.querySelector('[data-nhb-img]');
        var imgLink = card.querySelector('[data-nhb-img-link]');
        var nameLink = card.querySelector('[data-nhb-name-link]');

        if (priceEl) priceEl.textContent = formatMoney(chosen.price);
        if (compareAddonEl) {
          if (chosen.compare > chosen.price) {
            compareAddonEl.textContent = formatMoney(chosen.compare);
            compareAddonEl.style.display = '';
            if (priceEl) priceEl.className = 'nhb__price-sale';
          } else {
            compareAddonEl.style.display = 'none';
            if (priceEl) priceEl.className = '';
          }
        }

        var newImg = chosen.img || fallbackImg;
        if (newImg && imgEl) imgEl.src = newImg;

        var newUrl = productUrl + '?variant=' + chosen.id;
        if (imgLink) imgLink.href = newUrl;
        if (nameLink) nameLink.href = newUrl;

        recalc();
      });
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (ctaBtn.classList.contains('is-loading')) return;

        var items = [];
        items.push({ quantity: 1, id: parseInt(mainProduct.getAttribute('data-nhb-variant'), 10) });

        addons.forEach(function(card) {
          var cb = card.querySelector('input[type="checkbox"]');
          if (cb && cb.checked) {
            items.push({ quantity: 1, id: parseInt(card.getAttribute('data-nhb-variant'), 10) });
          }
        });

        ctaBtn.classList.add('is-loading');
        btnText.textContent = 'Wird hinzugef\u00FCgt\u2026';

        var idx = 0;
        function addNext() {
          if (idx >= items.length) {
            window.location.reload();
            return;
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: items[idx],
            success: function() { idx++; addNext(); },
            error: function() { idx++; addNext(); }
          });
        }
        addNext();
      });
    }

    recalc();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nh-upsell-quick"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('[id^="nhu-"]');
    if (!root) return;

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '\u00A0\u20AC';
    }

    root.querySelectorAll('[data-nhu-select]').forEach(function(sel) {
      var card = sel.closest('[data-nhu-card]');
      var variants = JSON.parse(sel.getAttribute('data-nhu-variants'));
      var productUrl = sel.getAttribute('data-nhu-product-url');
      var fallbackImg = sel.getAttribute('data-nhu-fallback-img');

      sel.addEventListener('change', function() {
        var vid = parseInt(sel.value, 10);
        var chosen = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === vid) { chosen = variants[i]; break; }
        }
        if (!chosen) return;

        var btn = card.querySelector('[data-nhu-id]');
        var priceEl = card.querySelector('[data-nhu-price]');
        var compareEl = card.querySelector('[data-nhu-compare]');
        var badgeEl = card.querySelector('[data-nhu-badge]');
        var imgEl = card.querySelector('[data-nhu-img]');
        var thumbLink = card.querySelector('[data-nhu-thumb-link]');
        var nameLink = card.querySelector('[data-nhu-name-link]');

        btn.setAttribute('data-nhu-id', chosen.id);
        btn.disabled = !chosen.available;

        priceEl.textContent = formatMoney(chosen.price);

        if (chosen.compare > chosen.price) {
          compareEl.textContent = formatMoney(chosen.compare);
          compareEl.style.display = '';
          card.classList.add('nhu__card--sale');
          if (badgeEl) {
            badgeEl.textContent = 'Spare ' + formatMoney(chosen.compare - chosen.price);
            badgeEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          card.classList.remove('nhu__card--sale');
          if (badgeEl) badgeEl.style.display = 'none';
        }

        var newImg = chosen.img || fallbackImg;
        if (newImg && imgEl) {
          imgEl.src = newImg;
          imgEl.style.display = '';
        }

        var newUrl = productUrl + '?variant=' + chosen.id;
        if (thumbLink) thumbLink.href = newUrl;
        if (nameLink) nameLink.href = newUrl;
      });
    });

    root.querySelectorAll('.nhu__add').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled || btn.classList.contains('is-loading')) return;

        var vid = parseInt(btn.getAttribute('data-nhu-id'), 10);
        btn.classList.add('is-loading');

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: { quantity: 1, id: vid },
          success: function() {
            window.location.reload();
          },
          error: function() {
            btn.classList.remove('is-loading');
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nov-social-proof"] && !Shopify.designMode) return;
  try {
    (function() {
    var purchaseElements = document.querySelectorAll('[data-social-proof="purchase"]');
    
    purchaseElements.forEach(function(el) {
      var countEl = el.querySelector('.social-proof-purchase__count');
      if (!countEl) return;
      
      var baseCount = parseInt(countEl.dataset.count, 10) || 10;
      var maxCount = parseInt(countEl.dataset.max, 10) || 25;
      var minCount = Math.max(2, Math.floor(maxCount * 0.2));
      
      function updateCount() {
        var variation = Math.floor(Math.random() * 3) - 1;
        var newCount = Math.max(minCount, Math.min(maxCount, baseCount + variation));
        baseCount = newCount;
        countEl.textContent = newCount;
        countEl.style.transform = 'scale(1.1)';
        setTimeout(function() {
          countEl.style.transform = 'scale(1)';
        }, 200);
      }
      
      countEl.style.transition = 'transform 0.2s ease';
      
      var interval = 60000 + Math.random() * 60000;
      setInterval(updateCount, interval);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
